import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { FormLabel } from 'components/Label'
import { Spacer } from 'components/Utility'

type Props = {
  disabled: boolean
  error?: string
  id?: string
  label?: string
  maxLength?: number
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  required: boolean
  rows: number
  value: string
}

const Textarea: FC<Props> = React.memo((props) => {
  const { disabled, error, id, label, maxLength, onBlur, onChange, placeholder = '', required, rows, value } = props

  const className = (() => {
    switch (true) {
      case typeof error !== 'undefined':
        return styles.textarea__input__error
      case typeof error === 'undefined':
        return styles.textarea__input
      default:
        return styles.textarea__input
    }
  })()

  return (
    <>
      {label && (
        <>
          <FormLabel id={id} label={label} required={required} />
          <Spacer size={8} />
        </>
      )}
      <div className={styles.textarea}>
        <textarea
          disabled={disabled}
          className={className}
          maxLength={maxLength}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={(e) => onChange(e)}
          rows={rows}
          value={value}
        />
        {maxLength && (
          <span className={styles.textarea__count}>
            {value.length}/{maxLength}
          </span>
        )}
      </div>
    </>
  )
})

export default Textarea
